import BrandEdit from "brand/edit/app";
import BrandList from "brand/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const brandRoute: RouteObject = {
  path: "brand",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: BrandList,
  }, {
    path: ":key/edit",
    loader: () => viewModel,
    Component: BrandEdit,
  }]
};